import React, { useState, useEffect } from "react";
import { ButtonGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Modal from "react-modal";
import { MdLock } from "react-icons/md";
import { ChartArea, Download, MessageCircle, MessageSquare, Search } from "lucide-react";
// import SpinImage from "/assets/images/subHeader/promotion-spin.99a0cd5f.png"

import User from "pages/Parts/User";
import Credit from "pages/Parts/Credit";
import Logo from "pages/Parts/Logo";

import { Menu, X } from "lucide-react";
import { addNewStyle, CRISTP_ID, wait, API, Event } from 'utils/Helper';
import { style } from "@mui/system";
import { AiOutlineHome } from "react-icons/ai";
import { PiGiftLight } from "react-icons/pi";
import { IoWalletOutline } from "react-icons/io5";
import { BiSupport } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { RxCross2 } from "react-icons/rx";
import ExploreModal from "./ExploreModal";
import Chat from "pages/Parts/Chat";
import { useTranslation } from "react-i18next";
import DynamicDeposit from "pages/Payment/DynamicDeposit";
import Login from "pages/Auth/Login";
import Register from "pages/Auth/Register";
import { GrSearchAdvanced } from 'react-icons/gr';
import { TbWorld } from 'react-icons/tb';
import Cookies from "js-cookie";
import socket from "utils/Socket";
import axios from "axios";



const ToggleButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 1001;
`;

const HeaderContainer = styled.header`
  background-color: #292d2e;
  height: 60px;
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0 20px;
  justify-content: end;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);

  @media (max-width: 450px) {
    padding: 0 10px;
  }

  @media (max-width: 250px) {
    padding: 0 5px;
  }
`;

const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  // padding-right:240px;

  @media (max-width: 381px) {
    gap: 5px;
  }
`;

const SubHeaderContainer = styled.div`
  background-color: #1e2024;
  display: none;
  // justify-content: center;
  padding: 10px 20px;
  width: 100%;
  position: absolute;
  // top: 80px;
  left: 0;
  z-index: -1000;

  @media (min-width: 577px) {
    display: none;
  }

  @media (max-width: 350px) {
    padding: 10px 0px;
  }
`;

const SubHeaderItem = styled.div`
  margin: 0 10px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const SubHeaderIcon = styled.div`
  display: flex;
  gap: 10px;
`;
const Subicon = styled.div`
  background-color: #0c0d0f;
  position: relative;
  cursor: pointer;
  width: 2.75rem; /* 11 * 0.25rem */
  height: 2.5rem; /* 10 * 0.25rem */
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.75rem;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 375px) {
    width: 2rem;
    height: 2rem;
    border-radius: 0.55rem;
  }
`;

const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(58 65 66);
  border-radius: 10px;
  padding: 6px 6px;
  width: 100%;
  max-width: 40px;
  transition: all 0.2s ease-in-out;
  border: ${(props) =>
    props.isFocused ? "2px solid #4caf50" : "2px solid transparent"};
  margin-right: 10px;
  cursor: pointer;
`;

const SearchBarContainerNew = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(58 65 66);
  border-radius: 10px;
  padding: 6px 6px;
  width: 100%;
  transition: all 0.2s ease-in-out;
  border: ${(props) =>
    props.isFocused ? "2px solid #4caf50" : "2px solid transparent"};
  margin-right: 10px;

  @media (max-width: 350px) {
    max-width: 30px;
    height: 30px;
  }
`;

const SearchInput = styled.input`
  background-color: transparent;
  border: none;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  margin-left: 8px;
  outline: none;

  &::placeholder {
    color: #a0a0a0;
  }
`;

const LogoContainer = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
  @media (max-width: 335px) {
    margin-right: 0px;
  }
`;

const FullLogo = styled.img`
  height: auto;
  width: 150px;
`;

const ShortLogo = styled.div`
  font-size: 20px;
  font-weight: bold;
  font-style: italic;
`;

const SubIconImage = styled.img`
  animation: spin 1s linear infinite;
  margin-top: -2px;
  width: 2.75rem;
  height: 2.75rem;

  @media (max-width: 375px) {
    width: 2rem;
    height: 2rem;
  }
`;

const SubIconImage1 = styled.img`
  margin-top: -2px;
  width: 2.75rem; /* 11 * 0.25rem (size-11) */
  height: 2.75rem;

  @media (max-width: 375px) {
    width: 2rem;
    height: 2rem;
  }
`;

const SubIconImage2 = styled.img`
  width: 2.1rem;
  height: 2.1rem;

  @media (max-width: 375px) {
    width: 1.75rem;
    height: 1.75rem;
  }
`;

const LocationImage = styled.img`
  position: absolute;
  width: 46px;
  height: 46px;
  transform: scaleX(-1);
  margin-left: 0px;
  transform-origin: center center;
  z-index: 22;
`;

const StyledImage1 = styled.img`
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 10px;
  opacity: 0.5;

  @media (max-width: 375px) {
    margin-right: 4px;
  }
`;

const LockImage = styled.div`
  position: absolute;
  width: 19px;
  height: 19px;
  z-index: 1;
  background-color: #454850;
  border-radius: 0.5625rem;
  right: -0.3125rem;
  top: -0.3125rem;

  @media (max-width: 375px) {
    width: 16px;
    height: 16px;
  }
`;

const StyledImage2 = styled.img`
  // margin-top: -2px;
  width: 1.5rem; /* 11 * 0.25rem (size-11) */
  height: 1.5rem;
  opacity: 0.5;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;

  @media (max-width: 425px) {
    gap: 0px;
  }
`;

const StyledImg = styled.img`
  height: 25px;
  width: 25px;
  filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg)
    brightness(94%) contrast(87%);
`;

const StyledImg2 = styled.img`
  height: 25px;
  width: 25px;
  filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg)
    brightness(94%) contrast(87%);
`;

const ShortLogoImg = styled.img`
  height: 50px;
  width: 60px;

  @media (max-width: 350px) {
    height: 20px;
    width: 20px;
  }
`;

const Subheaderothers = styled.div``;

const Header = ({ isCollapsedMobile, setIsCollapsedMobile, isAuthed }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showFullLogo, setShowFullLogo] = useState(window.innerWidth > 768);
  const [loaded, setLoaded] = useState(false);
  const [showSubHeader, setShowSubHeader] = useState(window.innerWidth <= 576);
  const [isChatModalOpen, setIsChatModalOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpen1, setModalOpen1] = useState(false);

  // Fetch siteConfig reactively so header re-renders when admin changes settings
  const [siteConfig, setSiteConfig] = useState(window?.siteConfig || {});
  useEffect(() => {
    const fetchConfig = () => {
      const API_URL = API || 'http://localhost:3009';
      fetch(`${API_URL}/website-config`)
        .then(r => r.json())
        .then(payload => {
          const data = payload?.success ? payload.data : payload;
          if (data) {
            window.siteConfig = { ...window.siteConfig, ...data };
            setSiteConfig({ ...data });
          }
        })
        .catch(() => {});
    };
    fetchConfig();
  }, []);

  const [notifications, setNotifications] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const notifRef = React.useRef(null);

  const getUid = () => {
    const val = Cookies.get("uid");
    return val ? parseFloat(val) : null;
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isAuthed) return;

    // Retry fetching with a small delay to ensure UID cookie is set
    const tryFetch = () => {
      const uid = getUid();
      if (uid && !isNaN(uid)) {
        fetchNotifications(uid);
      } else {
        // Cookie not ready yet, retry after 500ms
        setTimeout(() => {
          const retryUid = getUid();
          if (retryUid && !isNaN(retryUid)) fetchNotifications(retryUid);
        }, 500);
      }
    };
    tryFetch();

    const handleNewNotif = (newNotif) => {
      setNotifications((prev) => [newNotif, ...prev]);
    };
    socket.on('new_notification', handleNewNotif);

    return () => {
      socket.off('new_notification', handleNewNotif);
    };
  }, [isAuthed]);

  const fetchNotifications = async (uid) => {
    if (!uid || isNaN(uid)) return;
    try {
      const API_URL = API || 'http://localhost:3009';
      const res = await axios.get(`${API_URL}/api/notifications/${uid}`);
      if (res.data.status) {
        setNotifications(res.data.data);
      }
    } catch (err) {
      console.error('Notification fetch error:', err);
    }
  };

  const handleClearNotification = async (notifId, e) => {
    e.stopPropagation();
    const uid = getUid();
    try {
      const API_URL = API || 'http://localhost:3009';
      await axios.post(`${API_URL}/api/notifications/clear`, { uid, notificationId: notifId });
      setNotifications((prev) => prev.filter(n => n.id !== notifId));
    } catch (err) {
      console.error(err);
    }
  };

  const handleClearAll = async (e) => {
    e.stopPropagation();
    const uid = getUid();
    try {
      const API_URL = API || 'http://localhost:3009';
      await axios.post(`${API_URL}/api/notifications/clear-all`, { uid });
      setNotifications([]);
    } catch (err) {
      console.error(err);
    }
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const toggleModal1 = () => {
    setModalOpen1(!isModalOpen1);
  };

  const { t } = useTranslation();

  const handleTabClick = (e) => {
    const tabs = document.querySelectorAll(".snapbet-bottom-bar-main li a");
    tabs.forEach((tab) => tab?.classList?.remove("active"));
    e.currentTarget?.classList?.add("active");
    // Close the mobile sidebar overlay menu to prevent a black screen/overlay lock
    if (typeof setIsCollapsedMobile === 'function') {
      setIsCollapsedMobile(false);
    }
  };

  const support = () => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = CRISTP_ID;

    if (!loaded) {
      console.log("support");
      setLoaded(true);
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.id = "chtt";
      script.async = true;
      document.head.appendChild(script);
    }

    addNewStyle("#crisp-chatbox {display:block !important;}");
    addNewStyle(
      ".crisp-client .cc-kv6t .cc-1xry .cc-ge4v .cc-qqzz .cc-5b24 .cc-19cg {display:none !important;}"
    );

    wait(2000).then(() => {
      const close = document.querySelector(".cc-wdhl");
      if (close === null) return;
      close.addEventListener("click", function (event) {
        addNewStyle("#crisp-chatbox {display:none !important;}");
        document.getElementById("chtt").src = "";
      });
    });
  };

  useEffect(() => {
    const handleResize = () => {
      setShowFullLogo(window.innerWidth > 768);
      setShowSubHeader(window.innerWidth <= 576);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openChatModal = () => {
    setModalOpen(true);
  };

  const closeChatModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <HeaderContainer>
        <FlexContainer>
          {!showFullLogo && (
            <ToggleButton
              onClick={() => setIsCollapsedMobile(!isCollapsedMobile)}
            >
              {isCollapsedMobile ? (
                <X size={24} style={{ position: "absolute", left: "191px" }} />
              ) : (
                <Menu size={24} className="menu-icon-new" />
              )}
            </ToggleButton>
          )}
          <LogoContainer>
            <Link to="/">
              {showFullLogo ? (
                <FullLogo src={window?.siteConfig?.logo_big ? (API + window.siteConfig.logo_big) : "/assets/images/logo.png"} alt="Logo" />
              ) : (
                <ShortLogo>
                  <ShortLogoImg src={window?.siteConfig?.logo_small ? (API + window.siteConfig.logo_small) : "/assets/images/logo.png"} />
                </ShortLogo>
              )}
            </Link>
          </LogoContainer>
        </FlexContainer>

        <RightWrapper>
          {siteConfig?.show_app_download && siteConfig?.app_download_url && (
            <a 
              href={siteConfig.app_download_url.startsWith('http') ? siteConfig.app_download_url : `${API}/download-app`}
              target="_blank"
              rel="noopener noreferrer"
              title={`Download ${siteConfig.app_download_name || 'App'}`}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgb(58 65 66)",
                borderRadius: "10px",
                padding: "8px",
                cursor: "pointer",
                color: "#b3bec1",
                textDecoration: "none",
                width: "40px",
                height: "40px",
                transition: "all 0.2s ease-in-out"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#ffffff";
                e.currentTarget.style.backgroundColor = "#4caf50";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#b3bec1";
                e.currentTarget.style.backgroundColor = "rgb(58 65 66)";
              }}
            >
              <Download size={18} />
            </a>
          )}

          {showFullLogo && (
            <>
              <SearchBarContainer onClick={toggleModal1} isFocused={isFocused}>
                <img src="\assets\bcimages\bcheader\search-icon.svg" />
              </SearchBarContainer>
            </>
          )}

          {isAuthed ? (
            <>
              <Credit />
              <Link to="/promotions">
                <div className="header-gift">
                  <img src="\assets\bcimages\bcheader\gift_icon.svg" />
                </div>
              </Link>
              <div className="header-icons-bcgame">
                {/* <StyledImg2
                  style={{ cursor: "pointer" }}
                  onClick={openChatModal}
                  src="\assets\bcimages\bcheader\chat_icon.svg"
                /> */}
                <div ref={notifRef} style={{ position: 'relative' }}>
                  <StyledImg
                    src="\assets\bcimages\bcheader\notification_icon.svg"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    style={{ cursor: "pointer" }}
                  />
                  {notifications.length > 0 && (
                    <div className="mesaasge-top" style={{ position: 'absolute', top: -5, right: -5, background: 'red', color: 'white', borderRadius: '50%', padding: '2px 6px', fontSize: '10px', cursor: 'pointer' }} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                      {notifications.length}
                    </div>
                  )}
                  {isDropdownOpen && (
                    <div style={{ position: 'absolute', top: '40px', right: '-10px', width: '300px', backgroundColor: '#1e2024', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.3)', zIndex: 9999, border: '1px solid #333' }}>
                      <div style={{ padding: '10px', borderBottom: '1px solid #333', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h4 style={{ color: 'white', margin: 0, fontSize: '14px' }}>Notifications</h4>
                        {notifications.length > 0 && (
                          <button onClick={handleClearAll} style={{ background: 'transparent', border: 'none', color: '#ff4d4f', fontSize: '12px', cursor: 'pointer' }}>Clear All</button>
                        )}
                      </div>
                      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                        {notifications.length === 0 ? (
                           <div style={{ padding: '20px', textAlign: 'center', color: '#888', fontSize: '12px' }}>No new notifications</div>
                        ) : (
                          notifications.map(n => (
                            <div key={n.id} style={{ padding: '10px', borderBottom: '1px solid #333', position: 'relative' }}>
                              <h5 style={{ color: 'white', fontSize: '13px', margin: '0 0 5px 0', paddingRight: '20px' }}>{n.title}</h5>
                              <p style={{ color: '#aaa', fontSize: '11px', margin: 0 }}>{n.content}</p>
                              <span style={{ color: '#666', fontSize: '9px' }}>{new Date(n.date).toLocaleString()}</span>
                              <button onClick={(e) => handleClearNotification(n.id, e)} style={{ position: 'absolute', top: '10px', right: '10px', background: 'transparent', border: 'none', color: '#888', cursor: 'pointer', fontSize: '14px' }}>×</button>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <ButtonGroup>
                <User />
              </ButtonGroup>
            </>
          ) : (
            <>
              <Login />
              <Register />
            </>
          )}
        </RightWrapper>
      </HeaderContainer>

      {showSubHeader && (
        <SubHeaderContainer>
          <SubHeaderItem>
            {/* <StyledImg src="/assets/images/nanoicons/notification.png" /> */}
            <div style={{ display: "flex" }}>
              <SearchBarContainerNew isFocused={isFocused}>
                <img
                  className="search_Icon_header"
                  src="\assets\bcimages\bcheader\search-icon.svg"
                />
                <SearchInput
                  placeholder="Game name | Provider | Category Tag"
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                />
              </SearchBarContainerNew>
              <div className="header-gift2">
                <img src="\assets\bcimages\bcheader\gift_icon.svg" />
                {/* <div className="gift-top">1</div> */}
              </div>
            </div>
            {/* <div style={{ display: "flex", gap: "10px" }}>
              <div className="header-icons-bcgame2">
                <Link to="/chat">
                  <StyledImg2
                    style={{ cursor: "pointer" }}
                    onClick={openChatModal}
                    src="\assets\bcimages\bcheader\chat_icon.svg"
                  />
                </Link>
                <StyledImg src="\assets\bcimages\bcheader\notification_icon.svg" />
                <div className="mesaasge-top">1</div>
              </div>
            </div> */}
          </SubHeaderItem>
        </SubHeaderContainer>
      )}

      <div className="snapbet-bottom-bar">
        <ul className="snapbet-bottom-bar-main">
          <li>
            <Link to="/" className="active" onClick={handleTabClick}>
              <AiOutlineHome className="icon-home" size={24} style={{ color: "#ffffff", marginBottom: "2px" }} />
              <p>Home</p>
            </Link>
          </li>
          <li>
            <Link to="/affiliate" onClick={handleTabClick}>
              <img
                className="icon-home"
                src="/assets/bcimages/sidebar/affiliate.svg"
              />
              <p>Affiliate</p>
            </Link>
          </li>

          <li>
            <Link to="/casino" onClick={handleTabClick}>
              <img
                className="icon-home"
                src="/assets/bcimages/bchome/casino-home-gamecard.svg"
              />
              <p>Casino</p>
            </Link>
          </li>
          <li>
            <Link to="/vip-club" onClick={handleTabClick}>
              <img
                className="icon-home"
                src="/assets/bcimages/sidebar/vip.svg"
              />
              <p>VIP</p>
            </Link>
          </li>
          <li>
            <Link to="/promotions" onClick={handleTabClick}>
              <img
                className="icon-home"
                src="\assets\bcimages\bcheader\gift_icon.svg"
              />
              <p>Promotion</p>
            </Link>
          </li>
          <li onClick={() => {
            const uid = Cookies.get("uid") || localStorage.getItem("uid");
            if (uid) {
              Event.emit('force_modal_my_profile');
            } else {
              Event.emit('showAuthModal');
            }
          }} style={{ cursor: 'pointer' }}>
            <a onClick={handleTabClick}>
              <CgProfile className="icon-home" size={24} style={{ color: "#b3bec1", marginBottom: "2px" }} />
              <p>Profile</p>
            </a>
          </li>
        </ul>
      </div>

      {/* Modal Components */}
      <Modal
        isOpen={isModalOpen1}
        onRequestClose={toggleModal1}
        contentLabel="Search Modal"
        className="explore-modal-new"
        overlayClassName="custom-overlay"
      >
        <div style={{ width: "100%", height: "100%", backgroundColor: "#1a2c38" }}>
          <ExploreModal onClose={toggleModal1} />
        </div>
      </Modal>

      {/* Modal Components */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        contentLabel="Chat"
        className="custom-modal"
        overlayClassName="custom-overlay"
        style={{
          content: {
            padding: 0,
            backgroundColor: "#323738",
            width: "100%",
            margin: "auto",
            borderRadius: "10px",
          },
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.8)" },
        }}
      >
        {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px" }}>
          <h2 style={{ color: "white", margin: 0 }}>Chat</h2>
          <RxCross2 size={20} style={{ color: "white", cursor: "pointer" }} onClick={toggleModal} />
        </div> */}
        <div style={{ height: "calc(100% - 50px)" }}>
          <Chat t={t} toggleModal={toggleModal} />
        </div>
      </Modal>
    </>
  );
};

export default Header;
